export default __webpack_public_path__ + "static/media/bd.a5240232.png";